export const getSafeQueryStringArray = (param) => {
  return Array.isArray(param) ? param : [];
};
